import { fontStack } from '../../utils.js';

var fontFamily = fontStack([
/**
 * In an ideal world this would come from `@s-group/design-system-tokens`
 * @see https://docs.designsystem.s-cloud.fi/docs/design-tokens/typography#font-family-name
 */
'S Bonus UX', 'SBonus', 'Roboto', 'Arial', 'sans-serif']);

export { fontFamily };
//# sourceMappingURL=fontFamily.js.map
